import { Component, Prop, Vue } from 'vue-property-decorator';
import { Bot } from 'ignite360-core';

@Component
export class BotMixin extends Vue {
  @Prop({ required: true, type: Object })
  readonly bot!: Bot;
}
